import { createStore, combineReducers } from 'redux';
import API from './API';

var reducers = {};
var has_me = false;

function add_reducer(name, default_value) {
	reducers[name] = (state, action) => {
		if (action.type === name) {
			return action[name];
		} else {
			return state === undefined ? default_value : state;
		}
	}
}

function add_pref_reducer(name, default_value) {
	reducers[name] = (state, action) => {
		if (action.type === name) {
			const new_value = action[name];
			if (has_me && state !== new_value) {
				API.post("/a/prefs", {prefs: JSON.stringify({[name]: new_value})}, (r) => {});
			}
			return new_value;
		} else if (action.type === "init:" + name) {
			return action[name];
		} else {
			return state === undefined ? default_value : state;
		}
	}
}

function add_reducers(reducers) {
	for (var i = 0; i < reducers.length; i++) {
		const [name, default_value] = reducers[i];
		add_reducer(name, default_value);
	}
}

add_reducers([
	["me", false],
	["just_logged_in_with", null],
	["auth", ""],
	["fatal_error", false],
	["has_unverified_email", false],
]);

add_pref_reducer("LastGamePortfolioIdVisited", 0);

function add_integer_reducers(names) {
	for (var i = 0; i < names.length; i++) add_reducer(names[i], 0);
}

add_integer_reducers([
	"home_games_xtab_index",
	"home_stocklist_xtab_index",
	"home_stocklist_interval_xtab_index",
	"home_public_games_xtab_index",
	"unseen_notifications",
]);

reducers.modal_stack = (state, action) => {
	const copy_state = () => {
		var st = [];
		if (state) for (const e of state) st.push(e);
		return st;
	}

	var new_state;
	if (action.type === "push_modal") {
		new_state = copy_state();
		if (new_state.length === 0 || new_state[new_state.length-1].name !== action.modal.name) {
			new_state.push(action.modal);
		}
		return new_state;
	} else if (action.type === "pop_modal") {
		new_state = copy_state();
		if (new_state.length > 0) new_state.pop();
		return new_state;
	} else if (action.type === "update_modal") {
		new_state = copy_state();
		var new_modal = {...action.modal};
		const data_keep_set = new_modal.data_keep_set;
		delete new_modal.data_keep_set;
		if (new_state.length > 0) {
			const old_modal = new_state.pop();
			if (data_keep_set) {
				for (const k of data_keep_set) {
					new_modal.data[k] = old_modal.data[k];
				}
			}
		}
		new_state.push(new_modal);
		return new_state;
	} else {
		return state === undefined ? [] : state;
	}
};

var store = createStore(combineReducers(reducers));

store.dispatch_value = ((key, value) => {
	store.dispatch({type: key, [key]: value});
});

store.dispatch_me = (me => {
	if (me && me.User) {
		store.dispatch_value("me", me.User);
	} else {
		store.dispatch_value("me", null);
	}

	if (me && me.Prefs) {
		for (const key in me.Prefs) {
			store.dispatch({
				type: "init:" + key,
				[key]: me.Prefs[key]
			});
		}
	}

	if (me && me.Auth) {
		store.dispatch_value("auth", me.Auth);
	}

	if (me && me.JustLoggedInWith) {
		store.dispatch_value("just_logged_in_with", me.JustLoggedInWith);
	} else {
		store.dispatch_value("just_logged_in_with", null);
	}
});

store.push_modal = (name, data) => {
	store.dispatch({
		type: "push_modal",
		modal: {name, data},
	});
};

store.pop_modal = () => {
	store.dispatch({
		type: "pop_modal"
	});
}

store.update_modal = (name, data, data_keep_set) => {
	store.dispatch({
		type: "update_modal",
		modal: {name, data, data_keep_set},
	});
}

store.trigger_fatal_error = () => {
	store.dispatch({type: "fatal_error", fatal_error: true});
}

store.clear_fatal_error = () => {
	store.dispatch({type: "fatal_error", fatal_error: false});
}

store.subscribe(() => {
	const state = store.getState();
	if (!!state.me && !has_me) {
		has_me = true;
	} else if (!state.me && has_me) {
		has_me = false;
	}
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js